import { render, staticRenderFns } from "./manageCenter.vue?vue&type=template&id=9860c38c&scoped=true&"
import script from "./manageCenter.vue?vue&type=script&lang=js&"
export * from "./manageCenter.vue?vue&type=script&lang=js&"
import style0 from "./manageCenter.vue?vue&type=style&index=0&id=9860c38c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9860c38c",
  null
  
)

component.options.__file = "manageCenter.vue"
export default component.exports